import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/camera.svg';
const Camera = () => React.createElement(IconSvg, null);
export default Camera;
